export default {
  API: process.env.VUE_APP_ENDPOINT,
  MEDIADOMAIN: 'https://media.nhapkhaunamtrung.com',
  SHORT_DATE_FORMAT: "DD-MM-YYYY",
  DATE_FORMAT: "DD/MM/YYYY HH:mm:ss",
  SQL_DATE_FORMAT: "YYYY-MM-DD HH:mm:ss",
  SYSTEM_CONFIG: {
    domain: 'https://nhapkhaunamtrung.com',
    firebase_prefix: 'thanglinhlogistics',
    firebase_storage: 'https://firebasestorage.googleapis.com/v0/b/oee-app-cc5a1.appspot.com/o',
    quick_store_import: false,
    notification_time: 30,
    auto_pack_code: false,
    accountant_order_fee_column: false
  },
  PAGINATION: {
    page: 1,
    itemsPerPage: 20,
    mustSort: true,
    sortDesc: [1],
    sortBy: ["ID"]
  },
  ITEMS_PER_PAGE:{
    'items-per-page-options': [20, 30, 40, 50, 100, 200, 500]
  },
  
  ORDER_TYPE: {
    order: 1,
    deposit: 2
  },
  ORDER_TYPE_LIST: [
    { value: 1, name: 'Mua hộ' },
    { value: 2, name: 'Ký gửi' }
  ],
  ORDER_STATUS_ENUM: {
    cho_dat_coc: 0,
    huy: 1,
    da_dat_coc: 2,
    cho_bao_gia: 3,
    cho_mua_hang: 5,
    cho_tt_lan_2: 14,
    da_mua_hang: 6,
    dang_van_chuyen: 16,
    da_nhap_kho_tq: 11,
    van_chuyen_ve_vn: 12,
    da_nhap_kho_vn: 7,
    cho_thanh_toan: 8,
    da_xuat_kho: 9,
    khieu_nai: 13,
    hoan_thanh:10
  },
  ORDER_STATUS: [
    { value: 1, name: 'Hủy đơn hàng', disabled: false, color: '#1F2937', textColor: '#ffffff' },
    // { value: 3, name: 'Chờ báo giá', disabled: false, color: '#8B5CF6', textColor: '#ffffff' },
    { value: 0, name: 'Chờ đặt cọc', disabled: false, color: '#DC2626', textColor: '#ffffff' },
    { value: 2, name: 'Chờ mua hàng', disabled: false, color: '#16A34A', textColor: '#ffffff' },
    { value: 5, name: 'Đang mua hàng', disabled: false, color: '#0284C7', textColor: '#ffffff' },
    { value: 14, name: 'Chờ TT lần 2', disabled: false, color: '#D97706', textColor: '#ffffff' },
    { value: 6, name: 'Chờ phát hàng', disabled: false, color: '#0D9488', textColor: '#ffffff' },
    { value: 16, name: 'Shop phát hàng', disabled: false, color: '#DB2777', textColor: '#ffffff' },
    { value: 11, name: 'Đã nhập kho TQ', disabled: false, color: '#EA580C', textColor: '#ffffff' },
    { value: 12, name: 'Vận chuyển về VN', disabled: false, color: '#4F46E5', textColor: '#ffffff' },
    { value: 7, name: 'Đã nhập kho VN', disabled: false, color: '#053b2aff', textColor: '#ffffff' },
    { value: 9, name: 'Đã xuất kho', disabled: false, color: '#0d44bbff', textColor: '#ffffff' },
    { value: 13, name: 'Khiếu nại', disabled: false, color: '#C026D3', textColor: '#ffffff' },
    { value: 10, name: 'Hoàn thành', disabled: false, color: '#6B7280', textColor: '#ffffff' },
  ],
  ORDER_DEPOSIT_STATUS_ENUM: {
    dang_van_chuyen: 16,
    da_nhap_kho_tq: 11,
    van_chuyen_ve_vn: 12,
    da_nhap_kho_vn: 7,
    cho_thanh_toan: 8,
    da_thanh_toan: 9,
    hoan_thanh: 10,
    huy_don_hang: 1
  },
  ORDER_DEPOSIT_STATUS: [
    { value: 1, name: 'Hủy đơn hàng', color: '#1F2937', textColor: '#ffffff' },
    { value: 16, name: 'Shop phát hàng', color: '#DB2777', textColor: '#ffffff' },
    { value: 11, name: 'Đã nhập kho TQ', color: '#EA580C', textColor: '#ffffff' },
    { value: 12, name: 'Vận chuyển về VN', color: '#4F46E5', textColor: '#ffffff' },
    { value: 7, name: 'Đã nhập kho VN', color: '#059669', textColor: '#ffffff' },
    { value: 8, name: 'Chờ thanh toán', color: '#D97706', textColor: '#ffffff' },
    { value: 9, name: 'Đã xuất kho', color: '#2563EB', textColor: '#ffffff' },
    { value: 10, name: 'Hoàn thành', color: '#6B7280', textColor: '#ffffff' },
  ],
  PAY_SERVICE_STATUS_ENUM: {
    don_huy: 1,
    cho_bao_gia: 2,
    cho_thanh_toan: 3,
    da_thanh_toan: 4,
    hoan_thanh: 5
  },
  PAY_SERVICE_STATUS: [
    { value: 1, name: 'Đơn huỷ', color: '#000000', textColor: '#ffffff' },
    { value: 2, name: 'Chờ báo giá', color: '#F7819F', textColor: '#ffffff' },
    { value: 3, name: 'Chờ thanh toán', color: '#FACC2E', textColor: '#ffffff' },
    { value: 4, name: 'Đã thanh toán', color: '#FE9A2E', textColor: '#ffffff' },
    { value: 5, name: 'Hoàn thành', color: '#0000FF', textColor: '#ffffff' }
  ],
  VIP_LEVEL: [
    { value: 1, name: '', color: '' },
    { value: 2, name: 'v1', color: '#FFCC80' },
    { value: 3, name: 'v2', color: '#FFB74D' },
    { value: 4, name: 'v3', color: '#FFA726' },
    { value: 5, name: 'v4', color: '#FB8C00' },
    { value: 6, name: 'v5', color: '#F57C00' },
    { value: 7, name: 'v6', color: '#EF6C00' },
  ],
  PACKAGE_STATUS_ENUM: {
    CHUA_PHAT_HANG: 0,
    DANG_DI_CHUYEN: 1,
    DA_VE_TQ: 2,
    DANG_VE_VN: 3,
    DA_VE_VN: 4,
    KH_DA_NHAN: 5
  },
  PACKAGE_STATUS: [
    { value: 0, name: 'Chưa phát hàng', disabled: true, color: 'red', textColor: '#000' },
    { value: 1, name: 'Đang vận chuyển', disabled: false, color: 'black', textColor: '#FFF' },
    { value: 2, name: 'Đã về kho TQ', disabled: false, color: 'deep-purple', textColor: '#FFF' },
    { value: 3, name: 'Đang chuyển về VN', disabled: false, color: 'orange', textColor: '#FFF' },
    { value: 4, name: 'Đã về kho VN', disabled: false, color: 'green', textColor: '#FFF' },
    { value: 5, name: 'Đã giao hàng', disabled: false, color: 'blue', textColor: '#FFF' },
  ],
  BIG_PACKAGE_STATUS_ENUM: {
    DANG_DONG_BAO: 0,
    XUAT_KHO_TQ: 1,
    NHAP_KHO_VN: 2
  },
  BIG_PACKAGE_STATUS: [
    { value: 0, name: 'Đang đóng bao', disabled: true, color: 'red', textColor: '#000' },
    { value: 1, name: 'Xuất kho TQ', disabled: false, color: 'black', textColor: '#FFF' },
    { value: 2, name: 'Nhập kho VN', disabled: false, color: 'green', textColor: '#FFF' }
  ],
  VEHICLE_STATUS_ENUM: {
    DANG_XEP: 0,
    DA_XUAT_KHO: 1,
    KIEM_HOA_TQ: 2,
    THONG_QUAN: 3,
    KIEM_HOA_VN: 4,
    NHAP_KHO_VN: 5
  },
  VEHICLE_STATUS: [
    { value: 0, name: 'Đang xếp', color: 'orange', textColor: '#000' },
    { value: 1, name: 'Đã xuất kho', color: 'blue', textColor: '#FFF' },
    { value: 2, name: 'Kiểm hóa TQ', color: 'indigo', textColor: '#FFF' },
    { value: 3, name: 'Thông quan', color: 'cyan darken-2', textColor: '#FFF' },
    { value: 4, name: 'Kiểm hóa VN', color: 'deep-purple', textColor: '#FFF' },
    { value: 5, name: 'Nhập kho VN', color: 'green', textColor: '#FFF' }
  ],
  COMMENT_TYPE: [
    { value: 1, name: 'Công khai', color: '#2EBB32' },
    { value: 2, name: 'Nội bộ', color: '#dc3545' }
  ],
  CUSTOMER_STATUS: {
    InActive: 1,
    Actived: 2,
    Blocked: 3
  },
  CUSTOMER_STATUS_LIST: [
    { value: 1, name: 'Chưa kích hoạt', color: '#808080' },
    { value: 2, name: 'Đã kích hoạt', color: '#0059b3' },
    { value: 3, name: 'Đang bị khóa', color: '#e63900' },
  ],
  RECHARGE_STATUS: {
    Pending: 1,
    Approved: 2,
    Cancel: 3,
    Transferred: 4,
    Cash: 5,
  },
  RECHARGE_STATUS_LIST: [
    { value: 1, name: 'Chờ duyệt', color: '#808080', textColor: '#000' },
    { value: 2, name: 'Đã duyệt', color: '#0059b3', textColor: '#FFF' },
    { value: 3, name: 'Hủy', color: '#e63900', textColor: '#000' },
    // { value: 4, name: 'Chuyển khoản', color: '#00b300', textColor: '#FFF' },
    // { value: 5, name: 'Tiền mặt', color: '#2d8659', textColor: '#FFF' },
  ],
  WITHDRAW_STATUS: {
    Pending: 1,
    Approved: 2,
    Cancel: 3,
  },
  WITHDRAW_STATUS_LIST: [
    { value: 1, name: 'Chờ duyệt', color: '#dc3545', textColor: '#000' },
    { value: 2, name: 'Đã duyệt', color: '#0059b3', textColor: '#FFF' },
    { value: 3, name: 'Hủy lệnh', color: '#e63900', textColor: '#000' }
  ],
  PAYMENT_TYPE: {
    Deposit: 1,
    Complete: 2,
  },
  PAYMENT_TYPE_LIST: [
    { value: 1, name: 'Đặt cọc', color: '#2d8659', textColor: '#FFF' },
    { value: 2, name: 'Thanh toán', color: '#0059b3', textColor: '#FFF' },
  ],
  PAYMENT_STATUS: {
    DatCoc: 2,
    ThanhToan: 9,
    PhiShip: 10,
    PhiKhac: 11,
    NhanLaiCoc: 12
  },
  PAYMENT_STATUS_LIST: [
    { value: 2, name: 'Đặt cọc', color: '#2d8659', textColor: '#FFF' },
    { value: 9, name: 'Thanh toán', color: '#0059b3', textColor: '#FFF' },
    { value: 10, name: 'Phí ship', color: '#808080', textColor: '#FFF' },
    { value: 11, name: 'Phí khác', color: '#808080', textColor: '#FFF' },
    { value: 12, name: 'Nhận lại cọc', color: '#FFB74D', textColor: '#000' },
  ],
  COMPLAIN_STATUS: {
    New: 1,
    SaleCustomerServiceProcessing: 2,
    Finished: 3,
    Rejected: 4,
    PurchaseProcessing: 5,
    WaitingForMoreGoods: 6,
    WaitingForShopRefund: 7,
    ReturnGoods: 8,
    DirectorProcessing: 9,
    AccountantProcessing: 10,
  },
  COMPLAIN_STATUS_LIST: [
    { value: 1, name: 'Khiếu nại mới', color: 'red' },
    { value: 2, name: 'Sale/CSKH xử lý', color: 'green' },
    { value: 5, name: 'MH xử lý', color: 'teal' },
    { value: 6, name: 'Chờ hàng về thêm', color: 'deep-orange' },
    { value: 7, name: 'Chờ shop hoàn tiền', color: 'orange' },
    { value: 8, name: 'Đổi trả hàng', color: 'purple' },
    { value: 9, name: 'GĐ xử lý', color: 'indigo' },
    { value: 10, name: 'Kế toán xử lý', color: 'cyan' },
    { value: 3, name: 'Kết thúc khiếu nại', color: 'blue' },
    { value: 4, name: 'Từ chối', color: 'grey' }
  ],
  DECLARATION_STATUS: {
    Pending: 1,
    Locked: 2,
    Cancel: 3,
  },
  DATA_TYPE: {
    String: 0,
    Number: 1,
    Enum: 2,
    Date: 3
  },
  LIST_COMPARISON: [
    { name: 'Có chứa', value: 'contain', display: '({0})', dataType: 0 },
    { name: 'Không chứa', value: 'does_not_contain', display: '-({0})', dataType: 0 },
    { name: 'Bằng', value: 's_equal', display: '= {0}', dataType: 0 },
    { name: 'Khác', value: 's_does_not_equal', display: '!= {0}', dataType: 0 },
    { name: 'Bằng', value: 'equal', display: '= {0}', dataType: 1 },
    { name: 'Khác', value: 'does_not_equal', display: '!= {0}', dataType: 1 },
    { name: 'Lớn hơn', value: 'greater_than', display: '> {0}', dataType: 1 },
    { name: 'Lớn hơn hoặc bằng', value: 'greater_than_or_equal', display: '>= {0}', dataType: 1 },
    { name: 'Nhỏ hơn', value: 'less_than', display: '< {0}', dataType: 1 },
    { name: 'Nhỏ hơn hoặc bằng', value: 'less_than_or_equal', display: '<= {0}', dataType: 1 },
    { name: 'Bằng', value: 'in', display: '= [{0}]', dataType: 2 },
    { name: 'Khác', value: 'not_in', display: '!= [{0}]', dataType: 2 },
    { name: 'Bằng', value: 'd_equal', display: '= {0}', dataType: 3 },
    { name: 'Khác', value: 'd_does_not_equal', display: '!= {0}', dataType: 3 },
    { name: 'Lớn hơn', value: 'd_greater_than', display: '> {0}', dataType: 3 },
    { name: 'Lớn hơn hoặc bằng', value: 'd_greater_than_or_equal', display: '>= {0}', dataType: 3 },
    { name: 'Nhỏ hơn', value: 'd_less_than', display: '< {0}', dataType: 3 },
    { name: 'Nhỏ hơn hoặc bằng', value: 'd_less_than_or_equal', display: '<= {0}', dataType: 3 },
  ],
  ROLE_TYPE: {
    Admin: 1,
    Manager: 2,
    Purchase: 4,
    CustomerService: 8,
    InteralControl: 16,
    StoreVN: 32,
    StoreTQ: 64,
    Payment: 128,
    Config: 256,
    StoreTQ2: 512,
    Sale: 1024,
    Officer: 2048
  },
  ROLES: [
    { value: 1, name: 'Admin'},
    { value: 2, name: 'Quản lý'},
    { value: 4, name: 'Mua hàng'},
    { value: 8, name: 'CSKH'},
    { value: 16, name: 'Kiểm soát nội bộ'},
    { value: 32, name: 'Kho Việt Nam'},
    { value: 64, name: 'Kho Trung Quốc'},
    { value: 128, name: 'Kế toán'},
    // { value: 256, name: 'Cấu hình'},
    { value: 1024, name: 'Sale'},
    { value: 2048, name: 'Chứng từ'}
  ],
  TRADE_TYPE: [
    { value: 1, name: 'Đặt cọc'},
    { value: 2, name: 'Nhận lại tiền đặt cọc' },
    { value: 3, name: 'Thanh toán hóa đơn' },
    { value: 4, name: 'Nạp tiền' },
    { value: 5, name: 'Rút tiền' },
    { value: 6, name: 'Hủy lệnh rút tiền' },
    { value: 7, name: 'Xử lý khiếu nại' },
    { value: 8, name: 'Hủy lệnh chuyển tiền' },
    { value: 9, name: 'Voucher khách mới' },
  ],
  SIGNAL_TYPE: [
    { value: 0, name: 'Chưa ký nhận'},
    { value: 1, name: 'Đã ký nhận' },
    { value: 3, name: 'Kiểm hàng' },
    { value: 2, name: 'Khác' }
    
  ],
  RECHARGE_TYPE: {
    Vietinbank: 11,
    // Vietcombank: 2,
    // BIDV: 3,
    // AGRIBANK: 4,
    // Techcombank: 5,
    // ACB: 6,
    // VPbank: 7,
    // MBbank: 8,
    // VIB: 9,
    // SeaBank: 10,
    // PVcomBank: 11,
    // TPBank: 12,
    // MSB: 13,
    InternalDTX: 14,
    StockTQ: 15,
    Cash: 90,
    COD: 91,
    Yuan: 92,
  },
  RECHARGE_METHODS: [
    { value: 11, name: 'Viettinbank Cty'},
    // { value: 2, name: 'Vietcombank'},
    // { value: 3, name: 'BIDV'},
    // { value: 4, name: 'AGRIBANK'},
    // { value: 5, name: 'Techcombank'},
    // { value: 6, name: 'ACB'},
    // { value: 7, name: 'VPbank'},
    // { value: 8, name: 'MBbank'},
    // { value: 9, name: 'VIB'},
    // { value: 10, name: 'SeaBank'},
    // { value: 11, name: 'PVcomBank'},
    // { value: 12, name: 'TPBank'},
    // { value: 13, name: 'MSB'},
    { value: 90, name: 'Tiền mặt VP'},
    { value: 91, name: 'Tiền mặt Kho HN'}
  ],
  MONEY_SOURCES: [
    { value: 11, name: 'Vietinbank' },
    // { value: 2, name: 'Vietcombank' },
    // { value: 3, name: 'BIDV' },
    // { value: 4, name: 'AGRIBANK' },
    // { value: 5, name: 'Techcombank'},
    // { value: 6, name: 'ACB'},
    // { value: 7, name: 'VPbank'},
    // { value: 8, name: 'MBbank'},
    // { value: 9, name: 'VIB'},
    // { value: 10, name: 'SeaBank'},
    // { value: 11, name: 'PVcomBank'},
    // { value: 12, name: 'TPBank'},
    // { value: 13, name: 'MSB'},
    { value: 14, name: 'Nội bộ DTX' },
    { value: 15, name: 'Quỹ kho TQ' },
    { value: 90, name: 'Tiền mặt VP' },
    { value: 91, name: 'Tiền mặt Kho HN' },
    { value: 92, name: 'Yuan' },
    { value: 93, name: 'System' },
    { value: 99, name: 'Khác'}
    
  ],
  MONEY_COMMANDS: [
    
    { value: 1, name: 'Nạp tệ', type: 0, pay: 1 },
    { value: 2, name: 'Thu khác', type: 0, pay: 1 },
    { value: 3, name: 'Shop hoàn KN', type: 0, pay: 1 },
    { value: 4, name: 'Chi mua tệ', type: 1, pay: 1 },
    { value: 5, name: 'Chi phí nhân công', type: 1, pay: 1 },
    { value: 6, name: 'Thanh toán đối tác VCQT', type: 1, pay: 1 },
    { value: 7, name: 'Thanh toán đối tác VCVN', type: 1, pay: 1},
    { value: 8, name: 'Chi phí Marketing', type: 1, pay: 1 },
    { value: 9, name: 'Chi phí Quản lý', type: 1, pay: 1},
    { value: 10, name: 'Chi phí bán hàng', type: 1, pay: 1 },
    { value: 11, name: 'Chi phí khác', type: 1, pay: 1 },
    { value: 90, name: 'Chuyển tiền nội bộ', type: -1 },
    { value: 91, name: 'Khách nạp ví', type: 0},
    { value: 92, name: 'Khách rút tiền', type: 1 },
    { value: 93, name: 'Hủy nạp ví', type: 1},
    { value: 94, name: 'Hủy lệnh rút tiền', type: 0},
  ],
  PAYMENTORDER_STATUS: {
    Unpaid: 0,
    Paid: 1,
  },
  PAYMENTORDER_STATUS_LIST: [
    { value: 0, name: 'Chưa thanh toán', color: '#e63900', textColor: '#FFF' },
    { value: 1, name: 'Đã thanh toán', color: '#0059b3', textColor: '#FFF' },
  ],
  TUIKUAN_STATUS: {
    cho_xu_ly: 0,
    da_xu_ly: 1,
  },
  TUIKUAN_STATUS_LIST: [
    { value: 0, name: 'Chờ xử lý', color: '#e63900', textColor: '#FFF' },
    { value: 1, name: 'Đã xử lý (Tăng TKKH+PT)', color: '#0059b3', textColor: '#FFF' },
  ],
  PRICES_STATUS: {
    chua_kich_hoat: 0,
    da_kich_hoat: 1,
  },
  PRICES_STATUS_LIST: [
    { value: 0, name: 'Chưa kích hoạt', color: '#e63900', textColor: '#FFF' },
    { value: 1, name: 'Đã kích hoạt', color: '#0059b3', textColor: '#FFF' },
  ],
  PRICES_GLOBAL: {
    private: 0,
    public: 1,
  },
  PRICES_GLOBAL_LIST: [
    { value: 0, name: 'Giá riêng', color: '#e63900', textColor: '#FFF' },
    { value: 1, name: 'Giá chung', color: '#0059b3', textColor: '#FFF' },
  ],
  FLAG_TYPE: {
    cham_phat_hang: 1,
    cham_nhap_kho_tq: 2,
    cham_nhap_kho_vn: 3,
    cham_mua_don: 4,
    cham_thanh_toan_don: 5,
    cham_ke_khai: 6,
    cham_giao_hang: 7,
    cham_thanh_toan: 8,
    cham_xuat_hoa_don: 9,
  },
  FLAG_TYPE_LIST: [
    { value: 1, name: 'Chậm phát hàng' },
    { value: 2, name: 'Chậm nhập kho TQ' },
    { value: 3, name: 'Chậm nhập kho VN' },
    { value: 4, name: 'Chậm mua đơn' },
    { value: 5, name: 'Chậm thanh toán đơn' },
    { value: 6, name: 'Chậm kê khai' },
    { value: 7, name: 'Chậm giao hàng' },
    { value: 8, name: 'Chậm THANH TOÁN' },
    { value: 9, name: 'Chậm xuất hóa đơn' },
  ],
  EXPORT_RECEIPT_STATUS: [
    { value: 'chuan_bi', name: 'Chuẩn bị', color: '#e63900' },
    { value: 'cho_giao_lai', name: 'Chờ giao lại', color: '#ff9800ff' },
    { value: 'dang_giao', name: 'Đang giao', color: '#019412ff' },
    { value: 'da_xuat', name: 'Đã xuất', color: '#0059b3' },
    // { value: 'da_huy', name: 'Đã hủy', color: '#02101eff' }
  ],
  FINANCE_APPROVED_STATUS: [
    { value: 0, name: 'Chưa duyệt', color: '#e63900' },
    { value: 1, name: 'Đã duyệt', color: '#0059b3' }
  ],
  DECLARE_UNITS_LIST: [
    'BAG', 'BBL', 'DZN', 'FTK', 'GRM', 'KGM', 'KPR', 'LTR', 'MLT', 'MTK', 'MTQ', 'MTR',
    'PAIL', 'PCE', 'PKG', 'PR', 'ROL', 'SEK', 'SET', 'SOI', 'TAM', 'TNE', 'TO', 'UNA',
    'UNB', 'UNC', 'UNIT', 'UNK', 'UNL', 'UNT', 'UNV', 'UNY', 'USD', 'VI', 'YRD'
  ],
  DECLARE_STATUS_ENUM: {
    khoi_tao: 1,
    da_chot_khach: 2,
    khai_full: 3,
    gui_ke_khai: 4,
    hq_sua: 5,
    da_nhap_khau: 6
  },
  DECLARE_STATUS_LIST: [
    { value: 1, name: "Khởi tạo", color: '#e63900', textColor: '#FFF' },
    { value: 2, name: "Đã chốt khách", color: '#366ed6', textColor: '#FFF' },
    { value: 3, name: "Khai full", color: '#0f2042', textColor: '#FFF' },
    { value: 4, name: "Gửi Kê Khai", color: '#781694', textColor: '#FFF' },
    { value: 5, name: "HQ Sửa", color: '#41841a', textColor: '#FFF' },
    { value: 6, name: "Đã Nhập Khẩu", color: '#4ea0b0', textColor: '#FFF' }
  ],
  SHIP_METHODS: [
    { value: 1, name: 'Tự đến lấy' },
    { value: 2, name: 'Gửi xe' },
    { value: 3, name: 'Viettel Post' },
    { value: 6, name: 'Tàu 1' },
    { value: 5, name: 'Tàu 2' },
    { value: 4, name: 'Tàu 3' },
    { value: 7, name: 'grab' },
    { value: 8, name: 'vt post' },
    { value: 9, name: 'xe D' },
    { value: 10, name: 'ô tô AB' },
    { value: 11, name: 'ahamove' }
  ]
};
